import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { City, } from 'country-state-city';
import { useFormik } from 'formik';

import styles from './Jobseekers.module.css';
import Talents from '../../components/UI/Common/Talents/Talents';
import Subtitle from '../../components/UI/Common/Subtitle/Subtitle';
import FormField from '../../components/UI/UpdatedFormUI/FormField/FormField';
import SkillsList from '../../components/UI/Common/Skills/SkillsList/SkillsList';
import SkillsForm from '../../components/Forms/Common/SkillsForm/SkillsForm';
import BasicPopup from '../../components/UI/Popups/BasicPopup/BasicPopup';
import BubbleButton from '../../components/UI/Buttons/BubbleButton/BubbleButton';
import FormRangeField from '../../components/UI/UpdatedFormUI/FormRangeField/FormRangeField';
import FormSelectField from '../../components/UI/UpdatedFormUI/FormSelectField/FormSelectField';
import FormOptionField from '../../components/UI/UpdatedFormUI/FormOptionField/FormOptionField';
import HeroSectionLight from '../../components/Verification/HeroSectionLight/HeroSectionLight';
import { FilterIcons } from '../../assets/images/icons';
import { useDebounce, useGetCities, useGetEducationLevelsHook } from '../../utils/utilityHooks';
import { IoMdClose } from 'react-icons/io';

function Jobseekers() {
    const { t } = useTranslation();
    const location = useLocation();
    const [isOpenSkillsPopup, setIsOpenSkillsPopup] = useState(false);

    const query = new URLSearchParams(location.search);
    let initialTalentCountry = query.getAll('country') || [];
    let initialTalentCity = query.getAll('city') || [];
    let initialTalentLanguage = query.getAll('language') || [];
    let initialTalentNationality = query.getAll('nationality') || [];
    let initialTalentEducation = query.getAll('education') || [];
    let initialTalentGender = query.get('gender') || 'any';
    let initialTalentSearch = query.get('search') || '';
    let initialSortby = query.get('sortby') || 'relevance';

    if (initialTalentCountry?.length) {
        initialTalentCountry = initialTalentCountry[0]?.split(',');
    }
    if (initialTalentCity?.length) {
        initialTalentCity = initialTalentCity[0]?.split(',');
    }
    if (initialTalentLanguage?.length) {
        initialTalentLanguage = initialTalentLanguage[0]?.split(',');
    }
    if (initialTalentNationality?.length) {
        initialTalentNationality = initialTalentNationality[0]?.split(',');
    }
    if (initialTalentEducation?.length) {
        initialTalentEducation = initialTalentEducation[0]?.split(',');
    }

    const [talentSearch, setTalentSearch] = useState(initialTalentSearch);
    const [talentCountry, setTalentCountry] = useState(initialTalentCountry);
    const [talentLanguage, setTalentLanguage] = useState(initialTalentLanguage);
    const [talentNationality, setTalentNationality] = useState(initialTalentNationality);
    const [talentEducation, setTalentEducation] = useState(initialTalentEducation);
    const [talentGender, setTalentGender] = useState(initialTalentGender);
    const [talentCity, setTalentCity] = useState(initialTalentCity);
    const [talentExperience, setTalentExperience] = useState([0, 50]);
    const [salaryRange, setsalaryRange] = useState([0, 9000]);
    const [applyFilter, setApplyFilter] = useState(false);
    const [updateFilters, setupdateFilters] = useState({});
    const [sortby, setSortby] = useState(initialSortby);
    const handleFilterChange = (value) => {

        switch (value.target.name) {
            case 'filter_country':
                setTalentCountry(value.target.value);
                break;
            case 'filter_city':
                setTalentCity(value.target.value);
                break;
            case 'filter_language':
                setTalentLanguage(value.target.value);
                break;
            case 'filter_nationality':
                setTalentNationality(value.target.value);
                break;
            case 'filter_gender':
                setTalentGender(value.target.value);
                break;
            case 'filter_education':
                setTalentEducation(value.target.value);
                break;
            default:
                break;
        }

    }

    const handleFilterRangeChange = useDebounce((value) => {
        setTalentExperience(value);
    }, 0);
    const handleFilterSalaryRangeChange = useDebounce((value) => {
        setsalaryRange(value);
    }, 0);

    const handleFilterSearchChange = useDebounce((value) => {
        setTalentSearch(value.target.value);
    }, 700);

    const genderOptions = [
        { value: 'any', label: t('general.UI.any') },
        { value: 'male', label: t('forms.welcome_job_seeker.step_1.male') },
        { value: 'female', label: t('forms.welcome_job_seeker.step_1.female') }
    ];

    const educationLevels = useGetEducationLevelsHook();
    const filters = {
        gender: talentGender,
        minimum_experience: talentExperience[0],
        maximum_experience: talentExperience[1],
        minimum_salary: salaryRange[0],
        maximum_salary: salaryRange[1],
        search: talentSearch,
        sorted_by: sortby,
    };
    if (talentCountry?.length > 0) {
        filters.country = talentCountry;
    }
    if (talentLanguage?.length > 0) {
        filters.language = talentLanguage;
    }
    if (talentNationality?.length > 0) {
        filters.nationality = talentNationality;
    }
    if (talentEducation?.length > 0) {
        filters.education_level = talentEducation;
    }
    if (talentCity?.length > 0 && filters?.country?.length > 0) filters.city = talentCity

    const formik = useFormik({
        initialValues: {
            search: initialTalentSearch,
            show_verified_jobSeeker: false,
            show_with_valid_visa: false,
            country: initialTalentCountry,
            city: initialTalentCity,
            language: initialTalentLanguage,
            nationality: initialTalentNationality,
            education: initialTalentEducation,
            gender: initialTalentGender,
            skills: [] // Array of skill objects with `code` and `skillLevel`
        },
        onSubmit: (values) => {
            setApplyFilter(true)
            setTimeout(() => {

                setApplyFilter(false)
            }, 3000);
            const newObj = {
                ...filters,
                show_verified_jobSeeker: values.show_verified_jobSeeker,
                show_with_valid_visa: values.show_with_valid_visa,
                skills: values.skills.map(skill => ({
                    code: skill.code,
                    skillLevel: skill.skillLevel,
                }))
            }
            filters.sorted_by = sortby;
            newObj.sorted_by = sortby;
            setupdateFilters(newObj)
        },
    });
     useEffect(() => {
        if (Object.keys(updateFilters)?.length == 0) {

            setupdateFilters({ ...filters })
        }
    }, [updateFilters, filters])

    const handlePopupOpen = (popupName) => {
        if (popupName === 'skills') {
            setIsOpenSkillsPopup(true);
        }
    }

    const handleAddSkills = (values, options) => {
        let response = options.filter((e) => e.value === values.skills)[0]
        const updatedData = [...formik.values.skills, {
            ...{
                id: Date.now() + '-' + values.skills,
                code: response.id,
                name: values.skills,
                skillLevel: values.skillLevel,
            }
        },]
        formik.setFieldValue('skills', updatedData);
        handlePopupClose('skills');
    }
    const handlePopupClose = (popupName) => {
        if (popupName === 'skills') {
            setIsOpenSkillsPopup(false);
        }
    }
    const handleOptionRemove = (field, id) => {
        const filteredField = formik.values[field].filter((option) => option.id !== id);
        formik.setFieldValue(field, filteredField);
    }
    const citiesOptions = useGetCities(filters.country);

    const [isCrossAnimating, setIsCrossAnimating] = useState(false);
    const [toggleFilter, setToggleFilter] = useState(false)
    const handleToggleFilter = () => {
        if (toggleFilter) {
            setIsCrossAnimating(true);
            setTimeout(() => {
                setToggleFilter(!toggleFilter);
                setIsCrossAnimating(false);
            }, 300);
        } else {
            setToggleFilter(!toggleFilter);
        }
    };





    const [isFixed, setIsFixed] = useState(false);
    const buttonRef = useRef(null); // Reference for the button
    const [buttonPosition, setButtonPosition] = useState({ x: 0, y: 0 });
    const getButtonPosition = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const container = document.querySelector(`.${styles.filterContainer}`);
            const containerWidth = container.offsetWidth; // Gets the width of the container
            setButtonPosition({ x: rect.left, y: rect.top, width: containerWidth });
        }
    };
    useEffect(() => {
        getButtonPosition();
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            if (buttonRef.current) {
                let scrollY = window.scrollY
                if (scrollY < (buttonPosition.y / 3)) {
                    setIsFixed(true);
                }
                else {
                    setIsFixed(false);
                }
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [buttonPosition]);
    const resetAllStates = () => {
        setTalentSearch([]);
        setTalentCountry([]);
        setTalentLanguage([]);
        setTalentNationality([]);
        setTalentEducation([]);
        // setTalentGender([]);
        // setTalentExperience([0, 50]);
        setApplyFilter(false);
        setTalentCity([]);
    };

    const handleSortbyChange = async (value) => {
        await setSortby(value);
        resetAllStates();
        filters.sorted_by = value;
        setupdateFilters({ "gender": "any", "minimum_experience": 0, "maximum_experience": 50, "minimum_salary": 0, "maximum_salary": 9000, "search": [], "sorted_by": value });
    };

    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>FindCV - Discover Employees</title>
            </Helmet>

            <HeroSectionLight
                title={t('talents_list.title')}
                desc={t('talents_list.desc')} />
            <div className={styles.container}>
                <div className={toggleFilter ? `${styles.filterContainer}` : `${styles.filterContainer} ${styles.removeMargin}`}               >

                    <div
                        className={toggleFilter ? styles.filterHeader : `${styles.filterHeader} ${styles.removeMargin}`}
                        style={{ cursor: "default" }}
                    >
                        <p className={styles.filterHeading}>{t('jobs.filters')}</p>

                        {/* Cross Icon */}
                        {toggleFilter && (
                            <IoMdClose
                                onClick={handleToggleFilter}
                                size={20}
                                className={`${styles.filterIcon} ${isCrossAnimating ? styles.spinReverse : ''}`}
                            />
                        )}

                        {/* Filter Icon */}
                        {!toggleFilter && (
                            <img
                                src={FilterIcons}
                                onClick={handleToggleFilter}
                                alt="Filter icon"
                                className={`${styles.filterIcon} ${toggleFilter ? styles.fadeOut : styles.fadeIn}`}
                            />
                        )}
                    </div>
                    <form className={toggleFilter ? `` : `${styles.formHide}`}>
                        <div >
                            <FormField
                                name="filter_search"
                                label={t('talents.search')}
                                type="text"
                                hasBorder
                                placeholder={t('talents_list.search')}
                                icon="search"
                                onChange={handleFilterSearchChange}
                            />
                        </div>
                        <div>
                            <FormSelectField
                                name="filter_country"
                                placeholder={t('general.UI.select')}
                                label={t('talents.country_of_current_residence')}
                                type="country"
                                // options={['QA', 'AE', 'SA', 'BH', 'KW', 'OM']}
                                isMulti
                                hasBorder
                                onFormikChange={handleFilterChange}
                                value={talentCountry}
                            />
                        </div>
                        {filters?.country?.length > 0 && citiesOptions?.length > 0 &&
                            <div>
                                <FormSelectField
                                    name="filter_city"
                                    placeholder={t('general.UI.City')}
                                    label={t('general.UI.City')}
                                    type="default"
                                    options={citiesOptions}
                                    isMulti
                                    hasBorder
                                    onFormikChange={handleFilterChange}
                                    value={talentCity}
                                />
                            </div>
                        }
                        <div>
                            <FormSelectField
                                name="filter_nationality"
                                placeholder={t('general.UI.select')}
                                label={t('talents.nationality')}
                                type="nationality"
                                isMulti
                                hasBorder
                                onFormikChange={handleFilterChange}
                                value={talentNationality}
                            />
                        </div>
                        <div>
                            <FormSelectField
                                name="filter_education"
                                placeholder={t('general.UI.select')}
                                label={t('talents.education_level')}
                                type="default"
                                isMulti
                                hasBorder
                                onFormikChange={handleFilterChange}
                                options={educationLevels}
                                value={talentEducation}
                            />
                        </div>
                        <div>
                            <FormSelectField
                                name="filter_language"
                                placeholder={t('general.UI.select')}
                                label={t('talents.language')}
                                type="language"
                                isMulti
                                hasBorder
                                onFormikChange={handleFilterChange}
                                value={talentLanguage}
                            />
                        </div>
                        <div className={styles.create_job_block}>
                            <Subtitle
                                dark
                                hasButton
                                buttonText={t('general.UI.add')}
                                buttonOnClick={() => handlePopupOpen('skills')}
                            >
                                {t('forms.manage_job.subtitle_skills')}
                            </Subtitle>
                            <div style={{ marginBottom: 10 }}>
                                <SkillsList isDark skills={formik.values.skills} onRemove={handleOptionRemove} />
                            </div>
                        </div>
                        <div>
                            <FormRangeField
                                name="filter_experience"
                                label={
                                    t('talents.experience')}
                                type="radio"
                                dark
                                min={0}
                                max={50}
                                tipLabelStart={talentExperience[0] + " " + (talentExperience[0] > 0 ? t("general.UI.years") : t("general.UI.year"))}
                                tipLabelEnd={talentExperience[1] + " " + (talentExperience[1] > 0 ? t("general.UI.years") : t("general.UI.year"))}
                                defaultValue={talentExperience}
                                allowCross={false}
                                range
                                showTooltip
                                onChange={handleFilterRangeChange}
                            />
                        </div>
                        <div>
                            <FormRangeField
                                name="filter_experience"
                                label={
                                    t('talents_list.salary_range')}
                                type="radio"
                                dark
                                min={1000}
                                max={9000}
                                tipLabelStart={"$" + salaryRange[0]}
                                tipLabelEnd={"$" + salaryRange[1]}

                                defaultValue={salaryRange}
                                allowCross={false}
                                range
                                showTooltip
                                onChange={handleFilterSalaryRangeChange}
                            />
                        </div>
                        <div>
                            <FormOptionField
                                name="filter_gender"
                                label={t('talents.gender')}
                                type="radio"
                                dark
                                options={genderOptions}
                                onChange={handleFilterChange}
                                value={talentGender}
                            />
                        </div>
                        <div className={styles.profile_visibility}>
                            <FormOptionField
                                name="show_verified_jobSeeker"
                                dark
                                type="checkbox"
                                options={[
                                    { value: true, label: t('talents_list.show_verified_jobseekers') },
                                ]}
                                onChange={formik.handleChange}
                                value={formik.values.show_verified_jobSeeker}
                            />
                        </div>
                        <div className={styles.profile_visibility}>
                            <FormOptionField
                                name="show_with_valid_visa"
                                dark
                                type="checkbox"
                                options={[
                                    { value: true, label: t('talents_list.show_with_valid_visa') },
                                ]}
                                onChange={formik.handleChange}
                                value={formik.values.show_with_valid_visa}
                            />
                        </div>
                        <div
                            ref={buttonRef}
                            style={{
                                position: isFixed ? 'fixed' : 'static', // Fixed or normal position
                                bottom: isFixed ? '20px' : 'auto', // Fixed to bottom if out of view
                                left: isFixed ? `${buttonPosition.x}px` : 'auto', // Use original left position
                                zIndex: 1000, // Ensure the button stays on top
                                width: buttonPosition.width,
                                transition: 'all 0.3s ease', // Smooth transition
                            }}
                        >
                            <BubbleButton
                                onClick={() => {
                                    formik.handleSubmit()
                                    const target = document.querySelector('.jobseekersContainer')
                                    if (target) {
                                        window.scrollTo({
                                            top: target.offsetTop, behavior: 'smooth'
                                        });
                                    }
                                }}
                                dark headerDarkButton style={{ width: "100%" }}>{t('talents_list.apply_button')}</BubbleButton>
                        </div>



                    </form>
                </div>
                <div className={`${styles.jobseekersContainer} jobseekersContainer`}>
                    <Talents
                        per_page={5}
                        handleSortbyChange={handleSortbyChange}
                        initialSortBy={filters.sorted_by}
                        filters={updateFilters}
                        setTalentCountry={setTalentCountry}
                        setTalentGender={setTalentGender}
                        formik={formik}
                        setTalentNationality={setTalentNationality}
                    />
                </div>
                {isOpenSkillsPopup &&
                    <BasicPopup
                        isOpen={isOpenSkillsPopup}
                        closePopup={() => handlePopupClose('skills')}
                    >
                        <SkillsForm onSubmit={handleAddSkills} excludeSkills={formik.values.skills.map(option => option.name)} />
                    </BasicPopup>
                }
            </div>
        </div >
    );
}

export default Jobseekers;